import { isAxiosError } from 'axios';

export const logError = (title: string, error: unknown) => {
  console.error(title, error);
};

export const logServerError = (error: unknown) => {
  if (isAxiosError(error)) {
    logError('Server error', error.response?.data);
    return;
  }
  if (
    typeof error === 'object' &&
    !!error &&
    'clone' in error &&
    typeof error.clone === 'function' &&
    'json' in error &&
    typeof error.json === 'function'
  ) {
    error
      .clone()
      .json()
      .then((errorMessage: unknown) => {
        logError('Server error', errorMessage);
      });
    return;
  }
  logError('Server error', error);
};
